import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { publicEventApi } from 'src/app/services/constants/api.constants';
import { environment } from '../../../environments/environment';
import { HttpBaseService } from '@evento-ng/libs';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  cards: any[] = [];
  isMobile = false;
  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {
    if (window.screen.width < 768) this.isMobile = true;
  }

  ngOnInit(): void {
    this.spinner.show();
    this.dataService
      .get(`${publicEventApi}?creatorId=` + environment.CREATORID, {
        headers: { 'Accept-Language': this.translate.currentLang },
      })
      .subscribe(
        (res) => {
          this.cards = res.data;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
        }
      );
  }
}
